<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-16">
        <h4 class="mt-3 mb-4">Berechnung der Umsatzerwartung / Umsatzziele anhand durchgeführter Werbemaßnahmen</h4>
        
      </div>
    </div>
    
    <div class="row">
      <div :class="calcValues.revenue.isResult ? 'col-lg-7' : 'col-16' ">
        <p>Berechne mit diesem Rechner den erwarteten Gewinn und ermittle, ob Du bereits mit den ersten Bestellungen Deiner Neukunden Gewinn erzieltst? Du kannst auch die monatlichen Kosten Deiner Werbeagentur eingetragen und hast somit einen Überblick über Deinen Gesamterfolg.</p>
      
        <div class="row mt-5">
          <div class="col-xl-8">
            <label class="form-label">&empty; Warenkorbwert (Netto-Betrag!)</label>

            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatAvgBasket" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.avgBasket.suffix"></span>
            </div>
            

            <label class="form-label">&empty; Marge</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatAvgProfit" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.avgProfit.suffix"></span>
            </div>
            
            <label class="form-label">Werbebudget</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control"  v-model="formatBudget" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.budget.suffix"></span>
            </div>
            

            <label class="form-label">&empty; Klickpreis (Cost-Per-Click, CPC)</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control"  v-model="formatAvgCpc" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.avgCpc.suffix"></span>
            </div>

            <label class="form-label">Conversion-Rate</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control"  v-model="formatCr" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.cr.suffix"></span>
            </div>
          </div>

          <div class="col-xl-8">
            <h6>Agentur Betreuungskosten</h6>

            <label class="form-label">Betreuungspauschale</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatAgencyCosts" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.agencyCosts.suffix"></span>
            </div>

            <label class="form-label">Betreuungspauschale prozentual vom Werbebudget</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatAgencyCostsPercent" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.agencyCostsPercent.suffix"></span>
            </div>

            <label class="form-label">Umsatzbeteiligung</label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="formatAgencyCostsTurnoverPercent" @focus="$event.target.select()">
              <span class="input-group-text" v-html="calcValues.agencyCostsTurnoverPercent.suffix"></span>
            </div>
            

          </div>
        </div>
      </div>
      <div class="col-lg-8 offset-lg-1 mt-3" v-if="calcValues.revenue.isResult">
        <h5>Ergebnis</h5>
        <table width="100%" cellspacing="2" cellpadding="2" class="kpi-table-1">
          <tr>
            <td>Anzahl gekaufter Klicks: </td>
            <td><span class="sb-bold">{{ calcValues.clicks.formatted }} <span v-html="calcValues.clicks.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Anzahl Käufe / Neukunden: </td>
            <td><span class="sb-bold">{{ calcValues.orders.formatted }} <span v-html="calcValues.orders.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Umsatzziel: </td>
            <td><span class="sb-bold">{{ calcValues.turnover.formatted }} <span v-html="calcValues.turnover.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Wareneinsatz: </td>
            <td><span class="sb-bold">{{ calcValues.costOfSales.formatted }} <span v-html="calcValues.costOfSales.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Gewinn / Marge: </td>
            <td><span class="sb-bold">{{ calcValues.profit.formatted }} <span v-html="calcValues.profit.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Gewinn abzgl. Werbebudget: </td>
            <td><span class="sb-bold">{{ calcValues.marketingCosts.formatted }} <span v-html="calcValues.marketingCosts.suffix"></span></span></td>
          </tr>
          <tr>
            <td colspan="2" class="pt-4 pb-2"><span class="sb-bold">Agenturkosten</span></td>
          </tr>
          <tr>
            <td>Betreuungspauschale: </td>
            <td><span class="sb-bold">{{ calcValues.agencyCosts.formatted }} <span v-html="calcValues.agencyCosts.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Betreuungskosten <span class="sb-bold">{{ calcValues.agencyCostsPercent.formatted }} <span v-html="calcValues.agencyCostsPercent.suffix"></span></span> des Werbebudgets: </td>
            <td><span class="sb-bold">{{ calcValues.agencyCostsPercentOfBudget.formatted }} <span v-html="calcValues.agencyCostsPercentOfBudget.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Umsatzbeteiligung <span class="sb-bold">{{ calcValues.agencyCostsTurnoverPercent.formatted }} <span v-html="calcValues.agencyCostsTurnoverPercent.suffix"></span></span>: </td>
            <td><span class="sb-bold">{{ calcValues.participationInSales.formatted }} <span v-html="calcValues.participationInSales.suffix"></span></span></td>
          </tr>
          <tr>
            <td colspan="2" class="pt-4 pb-2"><span class="sb-bold">Gesamtkosten</span></td>
          </tr>
          <tr>
            <td>Agenturkosten gesamt: </td>
            <td><span class="sb-bold">{{ calcValues.agencyCostsSum.formatted }} <span v-html="calcValues.agencyCostsSum.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Werbekosten: </td>
            <td><span class="sb-bold">{{ calcValues.budget.formatted }} <span v-html="calcValues.budget.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Wareneinsatz: </td>
            <td><span class="sb-bold">{{ calcValues.costOfSales.formatted }} <span v-html="calcValues.costOfSales.suffix"></span></span></td>
          </tr>
          <tr>
            <td>Gesamtkosten: </td>
            <td><span class="sb-bold">{{ calcValues.costsSum.formatted }} <span v-html="calcValues.costsSum.suffix"></span></span></td>
          </tr>
          <tr>
            <td colspan="2" class="pt-4 pb-2"><span class="sb-bold">Erlöse</span></td>
          </tr>
          <tr>
            <td><span class="sb-bold">Erlöse gesamt:</span> </td>
            <td><span class="sb-bold">{{ calcValues.revenue.formatted }} <span v-html="calcValues.revenue.suffix"></span></span></td>
          </tr>
        </table>

        <p>Deine Kunden-Umsatz-Relation (KUR) beträgt: <span class="sb-bold">{{ calcValues.ctr.formatted }} <span v-html="calcValues.ctr.suffix"></span></span>.</p>
        <p><span v-if="calcValues.ctr.text != ''"><span class="sb-bold">{{ calcValues.ctr.text }}</span></span></p>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-16" v-if="calcValues.revenue.isResult">
        <div class="row">
          <div class="col-lg-8 col-cs">
            <apex-chart width="100%" height="400" :options="chartoptions1" :series="getChartData1"></apex-chart>
          </div>

          <div class="col-lg-8 col-cs">
            <apex-chart width="100%" height="400" :options="getChartOptions2" :series="getChartData2"></apex-chart>
          </div>
          <div class="col-lg-8 m-auto col-cs d-flex justify-content-center">
            <apex-chart width="100%" height="400" :options="getChartOptions3" :series="getChartData3"></apex-chart>

          </div>
        </div>
      </div>
    </div>


 </div>
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
  name: "salesTarget",
  components: {
    'apexChart': VueApexCharts,
  },
  data() {
    return {
      chartoptions1: {},
      chartoptions2: {},
      chartoptions3: {},
      colorData: ['#52388E', '#AD0267', '#A28AD9', '#250719',  '#707070', '#BFBFBF', '#FF4D6B'],
      colorLine: '#00EEBD',
      calcValues: {
        budget: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        avgBasket: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        avgProfit: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
        },
        avgCpc: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        cr: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
        },
        agencyCosts: {
          number: 0,
          formatted: '0,00',
          suffix: '&euro;',
          isResult: false,
        },
        agencyCostsSum: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        agencyCostsPercent: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        agencyCostsPercentOfBudget: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        agencyCostsTurnoverPercent: {
          number: 0,
          formatted: '0,00',
          suffix: '%',
          isResult: false,
        },
        clicks: {
          number: 0,
          formatted: '0',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        orders: {
          number: 0,
          formatted: '',
          formatDigits: 0,
          suffix: '',
          isResult: false,
        },
        turnover: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        costOfSales: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        profit: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        marketingCosts: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        ctr: {
          number: 0,
          formatted: '',
          suffix: '%',
          isResult: false,
          text: '',
        },
        participationInSales: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        revenue: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
        costsSum: {
          number: 0,
          formatted: '',
          suffix: '&euro;',
          isResult: false,
        },
      }

    }
  },
  mounted() {
  

    this.chartoptions1 = {...this.$chartconfig.chartOptionsColumn, ...{
      colors: ['#52388E', '#AD0267'],
      xaxis: {
          categories: ['Werbekosten / Neukunden'],
      },
      tooltip: {
        y: {
            formatter: function (val) {
                return val
            }
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
         },
         offsetY: -20,
         style: {
            colors: ["#250719"]
        }
      }
    }}

    this.chartoptions2 = {...this.$chartconfig.chartOptionsColumn, ...{
      colors: this.colorData,
      xaxis: {
          categories: ['Ziele / Kosten'],
      },
        plotOptions: {
          bar: {
              horizontal: false,
              columnWidth: '100%',
              endingShape: 'rounded',
              borderRadius: 3,
              dataLabels: {
                position: 'top', // top, center, bottom
              },
          },
      },   
      tooltip: {
        y: {
            formatter:  (val) => {
         
              return `${this.$utils.beautifier(val)} €`;
            },
        }
      },
      dataLabels: {
        enabled: true,
        formatter:  (val) => {
         
          return `${this.$utils.beautifier(val)} €`;
         },
         offsetY: -20,
         style: {
            colors: ["#250719"]
        }
      }
    }}

    this.chartoptions3 = {...this.$chartconfig.chartOptionsRadialBar, ...{
      colors: [this.colorLine],
      labels: ['Kosten-Umsatz-Relation'],
    }}
    
  },
  computed: {
    formatBudget: {
      get () {
        
        return this.getObj('budget').number;
      },
      set (value) {
        return this.setObj('budget', value, 1);
      }
    },
    formatAvgBasket: {
      get () {
        return this.getObj('avgBasket').number;
      },
      set (value) {
        return this.setObj('avgBasket', value, 1);
      }
    },
    formatAvgProfit: {
      get () {
        return this.getObj('avgProfit').number;
      },
      set (value) {
        return this.setObj('avgProfit', value, 1);
      }
    },
    formatAvgCpc: {
      get () {
        return this.getObj('avgCpc').number;
      },
      set (value) {
        return this.setObj('avgCpc', value, 1);
      }
    },
    formatCr: {
      get () {
        return this.getObj('cr').number;
      },
      set (value) {
        return this.setObj('cr', value, 1);
      }
    },
    formatAgencyCosts: {
      get () {
        return this.getObj('agencyCosts').number;
      },
      set (value) {
        return this.setObj('agencyCosts', value, 1);
      }
    },
    formatAgencyCostsPercent: {
      get () {
        return this.getObj('agencyCostsPercent').number;
      },
      set (value) {
        return this.setObj('agencyCostsPercent', value, 1);
      }
    },
    formatAgencyCostsTurnoverPercent: {
      get () {
        return this.getObj('agencyCostsTurnoverPercent').number;
      },
      set (value) {
        return this.setObj('agencyCostsTurnoverPercent', value, 1);
      }
    },
    getChartData1 () {
      return [{
          name: 'Anzahl gekaufter Klicks',
          data: [this.calcValues.clicks.number]
        },
        {
          name: 'Anzahl Käufe / Neukunden',
          data: [this.calcValues.orders.number]
        }]
    },
    getChartData2 () {
      return [{
          name: 'Wareneinsatz',
          data: [this.calcValues.costOfSales.number]
        },
        {
          name: 'Gewinn / Marge',
          data: [ this.calcValues.profit.number]
        },
        {
          name: 'Gewinn abzgl. Werbebudget',
          data: [ this.calcValues.marketingCosts.number]
        },
        {
          name: 'Agenturkosten gesamt',
          data: [this.calcValues.agencyCostsSum.number]
        },
        {
          name: 'Werbekosten',
          data: [ this.getObj('budget').number]
        },
        {
          name: 'Gesamtkosten',
          data: [ this.calcValues.costsSum.number]
        },
        {
          name: 'Erlöse gesamt',
          data: [ this.calcValues.revenue.number]
        }]
    },
    getChartData3 () {
      return [this.$utils.beautifier(this.calcValues.ctr.number, 'en-EN')]
    },
    getChartOptions3 () {
      return {...this.chartoptions3, ...{
        colors: [this.colorLine]
      }}
    },

    getChartOptions2 () {
      return {...this.chartoptions2, ...{
        colors: this.colorData
      }}
    }
  },
  methods: {
    
    setResult(name, result) {
      let obj = this.getObj(name);
      obj.isResult = result;
      this.calcValues[name] = obj;
    },
    setObj(name, value, calcResult) {
      let obj = this.getObj(name);
      obj.number = this.$utils.formatStr2Number(value);
      var digits = 2;
      if ('formatDigits' in obj) {
        digits = obj.formatDigits;
      }
      obj.formatted = this.$utils.beautifier(obj.number, 'de-DE', digits);
      //console.log(obj.number, obj.formatted);
      this.calcValues[name] = obj;

      if (calcResult) this.calcResult();
      return obj.number;
    },
    setObjContent(name, obj, calcResult) {
      this.calcValues[name] = obj;
      this.setObj(name, obj.number, calcResult);
    },
    getObj(name) {
      return this.calcValues[name];
    },
    calcResult() {

      let budget = this.calcValues.budget;
      let turnover = this.calcValues.turnover;
      let participationInSales = this.calcValues.participationInSales;
      let ctr = this.calcValues.ctr;
      let agencyCosts = this.calcValues.agencyCosts;
      let agencyCostsPercent = this.calcValues.agencyCostsPercent;
      let agencyCostsPercentOfBudget = this.calcValues.agencyCostsPercentOfBudget;
      let avgBasket = this.calcValues.avgBasket;
      let avgCpc = this.calcValues.avgCpc;
      let avgProfit = this.calcValues.avgProfit;
      let clicks = this.calcValues.clicks;
      let costOfSales = this.calcValues.costOfSales;
      let cr = this.calcValues.cr;
      let agencyCostsTurnoverPercent = this.calcValues.agencyCostsTurnoverPercent;
      let marketingCosts = this.calcValues.marketingCosts;
      let orders = this.calcValues.orders;
      let profit = this.calcValues.profit;
      let revenue = this.calcValues.revenue;
      let agencyCostsSum = this.calcValues.agencyCostsSum;
      let costsSum = this.calcValues.costsSum;

      //Anzahl gekaufter Klicks
      if (avgCpc.number > 0) {
        clicks.number = Math.floor(budget.number / avgCpc.number);
        this.setObj('clicks',  clicks.number, 0);
      }

      //Anzahl Käufe
      orders.number = Math.floor(clicks.number / 100 * cr.number);
      this.setObj('orders',  orders.number, 0);

      //Umsatz
      turnover.number = orders.number * avgBasket.number;
      this.setObj('turnover',  turnover.number, 0);

      //Wareneinsatz
      costOfSales.number = turnover.number / ((avgProfit.number / 100) +1);
      this.setObj('costOfSales',  costOfSales.number, 0);

      //Marge
      profit.number = turnover.number - (turnover.number / ((avgProfit.number / 100) + 1));
      this.setObj('profit',  profit.number, 0);

      //Gewinn (Marge - Werbebudget)
      marketingCosts.number = profit.number - budget.number;
      this.setObj('marketingCosts',  marketingCosts.number, 0);

      //Agenturkosten prozentual
      agencyCostsPercentOfBudget.number = budget.number / 100 * agencyCostsPercent.number;
      this.setObj('agencyCostsPercentOfBudget',  agencyCostsPercentOfBudget.number, 0);

      //Agenturkosten Umsatzbeteiligung
      participationInSales.number = turnover.number / 100 * agencyCostsTurnoverPercent.number;
      this.setObj('participationInSales',  participationInSales.number, 0);

      //Agenturkosten gesamt
      agencyCostsSum.number = agencyCosts.number + agencyCostsPercentOfBudget.number + participationInSales.number;
      this.setObj('agencyCostsSum',  agencyCostsSum.number, 0);

      //Gesamtkosten
      costsSum.number = agencyCostsSum.number + budget.number + costOfSales.number;
      this.setObj('costsSum',  costsSum.number, 0);

      //Erlöse
      revenue.number = turnover.number - costsSum.number;
      revenue.isResult = true;
      this.setObjContent('revenue',  revenue, 0);

      
      if(this.getObj('revenue').number <= 0) {
        this.colorData = this.$utils.replaceArrayElement(this.colorData,this.colorData.length - 1, '#FF4D6B');
      }  else {
        this.colorData = this.$utils.replaceArrayElement(this.colorData,this.colorData.length - 1, '#00EEBD');
      }

      //Kosten-Umsatz-Verhältnis
      if (turnover.number == 0) {

        ctr.number = 0;
        ctr.isResult = true;
        ctr.text = 'Au weia! Deine Kampagne läuft gar nicht gut. Du musst dringend Deine Maßnahmen analysieren, denn so wirfst Du nur Geld zum Fenster raus.';
        this.setObjContent('ctr',  ctr, 0);
        this.colorLine = '#FF4D6B'

      } else {

        ctr.number = budget.number / turnover.number * 100;
        ctr.isResult = true;
        this.setObjContent('ctr',  ctr, 0);

        if (ctr.number > 0
            && ctr.number <= 1
        ) {

          ctr.text = 'Deine Kampagne ist perfekt. Besser gehts nicht, bravo!';
          ctr.isResult = true;
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#00EEBD'

        } else if (ctr.number > 1
            && ctr.number < 10
        ) {

          ctr.text = 'Deine Kampagne läuft super. Es geht kaum besser, bravo!';
          ctr.isResult = true;
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#00EEBD'

        } else if (ctr.number >= 10
            && ctr.number <= 20
        ) {

          ctr.text = 'Deine Kampagne läuft gut. Versuche noch ein paar Optimierungen durchzuführen und Deine Kampagnen laufen perfekt.';
          ctr.isResult = true;
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#FCDB8F'

        } else if (ctr.number > 20
            && ctr.number <= 30
        ) {

          ctr.text = 'Deine Kampagne performt noch nicht und ist durchwachsen. Versuche sie zu optimieren.';
          ctr.isResult = true;
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#FCDB8F'

        } else {

          ctr.text = 'Au weia! Deine Kampagne läuft gar nicht gut. Du musst dringend Deine Maßnahmen analysieren, denn so wirfst Du nur Geld zum Fenster raus.';
          ctr.isResult = true;
          this.setObjContent('ctr',  ctr, 0);
          this.colorLine = '#FF4D6B'

        }

      }

    }
  }
}
</script>
<style scoped>
 table tr td:first-child + td{
  text-align:right;
 }
</style>